import { Component, OnInit } from '@angular/core';
import {appVersion,versionType,applicationName,compilationDate} from '../../../../environments/environment';
@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  public applicationData:any = {
    appVersion : "",
    versionType: "",
    applicationName: ""
  };
  constructor() {
    this.applicationData = {
      appVersion : appVersion,
      versionType: versionType.versionType,
      applicationName: applicationName,
      compilationDate:compilationDate
    };
  }

  ngOnInit() {}

}
